import styled, { css } from 'styled-components';

const disabledStyleBtn = css`
  color: #9C9C9C;
  background: #ECECEC;
  cursor: not-allowed;
  &:hover {
    background: #ECECEC;
  }
`;

export const BlueBtn = styled.button`
  width: 100%;
  height: 45px;
  border-radius: 2px;
  text-align: center;
  color: rgb(255, 255, 255);
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: auto;
  cursor: pointer;
  background: #3091fd;
  border-radius: 4px;
  &:hover {
    background: #005abe;
  }
  ${props => props.$isDisabled && disabledStyleBtn}
`;

export const Wrapper = styled.div`
  width: 100vw;
  background: rgba(42, 42, 42, 0.61);
  justify-content: center;
  align-items: center;
  display: flex;
  transition: all 0.4s ease-in-out;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  overflow-y: scroll;
`;

export const Content = styled.div`
  width: 400px;
  border-radius: 2px;
  box-shadow: rgba(69, 65, 78, 0.08) 0px 1px 15px 0px;
  border: 1px solid #eeeeee;
  background-color: #fff;
  padding: 30px 25px;
  position: relative;
  margin: 100px;
  display: flex;
  flex-direction: column;

  .des {
    font-size: 14px;
    text-align: left;
  }
  .info {
    font-size: 13px;
    font-weight: 300;
    color: #222;
    text-align: center;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    margin: 0;
    padding-top: 80px;
    background-color: #f3f3f1;
  }
`;

export const LinkButton = styled.button`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: var(--primaryDark);
  text-decoration: none;
  text-align: center;
  display: inherit;
  margin: 0 auto;
`;
